import React from "react";
import ImageUploadField from "./ImageUploadField";
import VideoUploadField from "./VideoUploadField";

/*
  Business Website manager — "Product" tab (CR B1).
  Products & Services with direct product-image upload (CR B3), the
  photo gallery with direct upload (CR B2), and a Gallery video (upload
  a file, or paste a YouTube link — note item 5).
*/
export default function BizProductTab({ products, setProducts, updList, gallery, setGallery, form, set, personaluid }) {
    return (
        <>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Products &amp; Services</span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setProducts([...products, { category: "", name: "", image: "", price: "", unit: "", description: "" }])}>+ Add Product</button>
                </div>
                <div className="card-body">
                    {products.map((p, i) => (
                        <div className="border rounded p-2 mb-2" key={i}>
                            <div className="row g-2">
                                <div className="col-md-4"><input placeholder="Product name *" className="form-control form-control-sm" value={p.name} onChange={(e) => updList(products, setProducts, i, "name", e.target.value)} /></div>
                                <div className="col-md-4"><input placeholder="Category" className="form-control form-control-sm" value={p.category} onChange={(e) => updList(products, setProducts, i, "category", e.target.value)} /></div>
                                <div className="col-md-3"><input placeholder="Price (blank = Ask Price)" className="form-control form-control-sm" value={p.price} onChange={(e) => updList(products, setProducts, i, "price", e.target.value)} /></div>
                                <div className="col-md-1"><button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => setProducts(products.filter((_, x) => x !== i))}>×</button></div>
                                <div className="col-md-3"><input placeholder="Unit (piece/kg)" className="form-control form-control-sm" value={p.unit} onChange={(e) => updList(products, setProducts, i, "unit", e.target.value)} /></div>
                                <div className="col-md-9">
                                    <ImageUploadField value={p.image} onChange={(v) => updList(products, setProducts, i, "image", v)} purpose="product" personaluid={personaluid} placeholder="Upload product image" allowUrl={false} />
                                </div>
                                <div className="col-12"><input placeholder="Short description" className="form-control form-control-sm" value={p.description} onChange={(e) => updList(products, setProducts, i, "description", e.target.value)} /></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Gallery Photos</span>
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setGallery([...gallery, ""])}>+ Add</button>
                </div>
                <div className="card-body">
                    {gallery.map((g, i) => (
                        <div className="row g-2 mb-2 align-items-start" key={i}>
                            <div className="col-md-11">
                                <ImageUploadField value={g} onChange={(v) => { const c = [...gallery]; c[i] = v; setGallery(c); }} purpose="gallery" personaluid={personaluid} placeholder="Upload gallery photo" />
                            </div>
                            <div className="col-md-1"><button type="button" className="btn btn-sm btn-outline-danger w-100" onClick={() => setGallery(gallery.filter((_, x) => x !== i))}>×</button></div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Gallery Video</div>
                <div className="card-body">
                    <p className="text-muted small mb-2">Upload a video from your browser, and/or paste a YouTube link — either (or both) will show up in the Videos tab on your live site.</p>
                    <VideoUploadField value={form.gallery_video} onChange={(v) => set("gallery_video", v)} personaluid={personaluid} />
                    <input
                        type="text"
                        className="form-control form-control-sm mt-2"
                        placeholder="https://youtube.com/watch?v=..."
                        value={form.youtube_link}
                        onChange={(e) => set("youtube_link", e.target.value)}
                    />
                </div>
            </div>
        </>
    );
}